import {LOGIN, LOGOUT} from "../constants/userActionTypes";

const initialState = {
    user: null
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN:
            localStorage.setItem('Gein[user]', JSON.stringify(action.payload));
            return {...state, user: action.payload};
        case LOGOUT:
            localStorage.removeItem('Gein[user]');
            return {...state, user: {}};
        default:
            return state;
    }
};

export default userReducer;


// WEBPACK FOOTER //
// ./src/reducers/userReducer.js